import React from "react";
import Swal from "sweetalert2";  // Import SweetAlert2
import { FiX } from "react-icons/fi";  // Import cross icon from react-icons
import "../Category/CardPopup.css";

const CartPopup = ({ product, onClose, updateCart }) => {
  if (!product) return null;

  // Handle quantity change (decrement or increment)
  const handleQuantityChange = (amount) => {
    const newQuantity = product.quantity + amount;
    if (newQuantity > 0) {
      updateCart(product.id, newQuantity);  // Update quantity if > 0
    }
  };

  // Use the image from the public folder (assuming images are in /public/images/)
  const imageSrc = `${product.image}`;

  // Show SweetAlert when "Add to Cart" is clicked
  const handleAddToCart = () => {
    // Trigger SweetAlert
    Swal.fire({
      title: "Added to Cart!",
      text: `${product.name} has been successfully added to your cart.`,
      icon: "success",
      confirmButtonText: "OK",
    }).then(() => {
      onClose();  // Close the popup after SweetAlert confirmation
    });
  };

  return (
    <div className="cart-popup">
      <div className="popup-content">
        {/* Close Button */}
        <button className="close-popup" onClick={onClose}>
          <FiX />
        </button>

        {/* Product Image */}
        <div className="popup-image">
          <img src={imageSrc} alt={product.name} />
        </div>

        {/* Product Details */}
        <div className="popup-details">
          <h3>{product.name}</h3>
          <p>{product.description || "No description available."}</p>
          <div className="popup-price">
            <span>Total Price: </span>
            <strong>₹{(product.price * product.quantity).toFixed(2)}</strong>
          </div>

          {/* Quantity Controls */}
          <div className="popup-quantity">
            <button onClick={() => handleQuantityChange(-1)}>-</button>
            <span>{product.quantity}</span>
            <button onClick={() => handleQuantityChange(1)}>+</button>
          </div>

          {/* Add to Cart Button */}
          <button className="add-to-cart" onClick={handleAddToCart}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPopup;
